import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import FooterNew from "../Components/FooterNew";
import QuickLinks from "./QuickLinks";

const SurgicalProcedures = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Surgical Procedures
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div>
        <div
          className="about-summary-inline "
          style={{
            marginTop: "100px",
            padding: "5px ",
            
          }}
        >
          <p style={{fontWeight:"550", fontSize:"22px"}}>Dr Ahmed offers a range of surgical skin procedures including:</p>
          <ul className="m-3" style={{ lineHeight: "60px", fontSize:"19px" }}>
            <li>Skin biopsies</li>
            <li>Removal of Benign moles</li>
            <li>Removal of Cancerous moles</li>
            <li>Removal of Squamous Cell Carcinomas</li>
            <li>Removal of Basal Cell Carcinomas</li>
            <li>Removal of Warts</li>
            <li>Removal of Skin Tags</li>
            <li>Removal of Melanomas</li>
            <li>Removal of Seborrhoeic Keratoses</li>
            <li>Removal of Keloid Scars</li>
            <li>Removal of Actinic Keratoses</li>
            <li>Removal of Cysts</li>
            <li>Removal of Lipomas</li>
          </ul>
          <p  style={{fontSize:"19px", }} className="surgicalProcedure-below">
            Dr Ahmed also offers his expertise in skin flap reconstruction and
            minor skin graft after removal of skin cancers.
          </p>
        </div>
      </div>
      <div className="footer-import mt-5 ">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default SurgicalProcedures;
